import { Card } from '@mui/material';

/**
 * Card padronizado — aplica visualmente o padrão de cards do projeto.
 *
 * Sem noAccent (padrão): borda completa + accent esquerda primária.
 * Com noAccent: apenas borda uniforme, sem destaque (cards de dashboard).
 * Com accentColor: accent border em cor customizada.
 *
 * Resolve dois problemas do padrão anterior:
 *  - elevation: 0 não funciona dentro de sx (é prop do Card, não CSS)
 *  - Cada página repetia 5-6 linhas de sx inline para conseguir o mesmo resultado
 *
 * @param {boolean}  noAccent     - Remove a border-left de destaque (default: false)
 * @param {string}   accentColor  - Cor MUI theme path da accent border (default: 'primary.main')
 * @param {boolean}  fillHeight   - height: 100% + flex column (default: true)
 * @param {ReactNode} children
 * @param {Object}   sx           - sx extra mesclado sobre os estilos padrão
 * @param {*}        props        - demais props repassadas ao MUI Card
 *
 * @example
 * // Card de listagem com accent
 * <StandardCard>
 *   <CardContent>...</CardContent>
 * </StandardCard>
 *
 * // Card de dashboard, sem accent
 * <StandardCard noAccent>
 *   <CardContent>...</CardContent>
 * </StandardCard>
 *
 * // Card de dashboard com hover desabilitado
 * <StandardCard noAccent sx={{ '&:hover': { transform: 'none' } }}>
 *   <CardContent>...</CardContent>
 * </StandardCard>
 */
export default function StandardCard({
  noAccent = false,
  accentColor = 'primary.main',
  fillHeight = true,
  children,
  sx,
  ...props
}) {
  const baseSx = {
    border: '1px solid',
    borderColor: 'divider',
    ...(fillHeight ? { height: '100%', display: 'flex', flexDirection: 'column' } : {}),
    ...(!noAccent ? {
      borderLeft: '3px solid',
      borderLeftColor: accentColor,
    } : {}),
  };

  return (
    <Card elevation={0} sx={[baseSx, sx]} {...props}>
      {children}
    </Card>
  );
}
